import { useState, useEffect } from 'react';
import { AVAILABLE_LANGUAGES } from '../constants/doctorOptions';
import type { AvailableLanguage } from '../types/doctor';

/**
 * 対応可能言語のマスターデータを取得するカスタムフック
 * 
 * 意図：
 * - 対応可能言語のマスターデータを提供
 * - 将来的にAPIから取得する場合の拡張性を確保
 * 
 * 注意点：
 * - 現在は定数から取得しているが、将来的にはAPIから取得する可能性がある
 * - バックエンドの値と同期を保つ必要がある
 */
export const useAvailableLanguages = () => {
  const [languages, setLanguages] = useState<AvailableLanguage[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // 現在は定数から取得
    // 将来的にAPIから取得する場合はここを変更
    try {
      setLanguages(AVAILABLE_LANGUAGES);
      setIsLoading(false);
    } catch (err) {
      setError('対応可能言語の取得に失敗しました');
      setIsLoading(false);
    }
  }, []);

  return {
    languages,
    isLoading,
    error
  };
};